<template>
    <div class="orderconfirm">
        <div class="steps">
            <div class="steps_box">
                <el-steps :active="active" finish-status="success">
                    <el-step title="确认订单信息"></el-step>
                    <el-step title="确认付款"></el-step>
                    <el-step title="完成订购"></el-step>
                </el-steps>
            </div>
        </div>
        <div class="result">
            <div v-if="result === 'Y'" class="result_box success">
                <img :src="successImg">
                <div class="s_tips">
                    <h3>支付成功</h3>
                    <p>已完成服务订购，您可以查看此服务</p>
                </div>
                <div class="s_btns">
                    <div class="gray" @click="goBack">返回</div>
                    <!-- <div class="blue">查看服务</div> -->
                </div>
            </div>
            <div v-else class="result_box fail">
                <img :src="failImg">
                <div class="s_tips">
                    <h3>充值失败</h3>
                    <p>未完成服务订购，请查看订单并重新支付</p>
                </div>
                <div class="s_btns">
                    <div class="blue" @click="checkOrder">查看订单</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {queryOrderPayResult} from '@/api/orderService'
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'payResult',
    data() {
        return {
            active: 3,
            successImg: require('@/common/images/service/success.png'),
            failImg: require('@/common/images/service/fail.png'),
            token: JSON.parse(sessionStorage['user']).loginToken, // token
            shopID: JSON.parse(sessionStorage['shop']).ShopID, // 店铺id
            orderno: this.$route.query.orderid,
            sessionUser: JSON.parse(sessionStorage['user']),
            rid: this.$route.query.rid,
            result: this.$route.query.result,
            sign: this.$route.query.sign,
            flag: this.$route.query.flag
        }
    },
    mounted() {
        if (!this.flag) this.getPayResultInfo()
    },
    methods: {
        // 查询支付结果
        getPayResultInfo() {
            let data = {
                // LoginToken: this.token,
                // ShopID: this.shopID,
                orderno: this.orderno,
                rid:  this.rid,
                result:  this.result,
                sign:  this.sign,
            }
            this.setLoading(true)
            queryOrderPayResult({
                data: data,
                success: data => {
                    this.setLoading(false)
                    if (data.data) {
                       let resData = data.data

                    }
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },

        // 返回
        goBack() {
            this.$router.push({name: 'OrderService'})
        },

        // 查看订单
        checkOrder() {
            this.$router.push({name: 'orderDetail', query: {'orderno': this.orderno}})
        },

        ...mapActions ([
            'setLoading'
        ])
    }
}
</script>

<style lang="scss">
.orderconfirm {
    background: #fff;
    height: 90vh;
    .steps {
        padding: 40px 30px 20px;
        .steps_box {
            /*width: 1080px;*/
            margin: 0 auto;
            .el-steps {
                .el-step {
                    .el-step__head {
                        .el-step__line {
                            top: 22px;
                        }
                        .el-step__icon {
                            width: 40px;
                            height: 40px;
                            .el-step__icon-inner {
                                font-size: 20px;
                                color: #303133;
                            }
                            .el-icon-check {
                                color: #409EFF;
                            }
                        }
                    }
                    .is-success {
                        color: #409EFF;
                        border-color: #409EFF;
                    }
                    .el-step__main {
                        .el-step__title {
                            font-size: 16px;
                            color: #303133;
                            font-weight: 500;
                        }
                        .is-success {
                            color: #409EFF;
                        }
                    }
                }
            }
        }
    }
    .result {
        margin-top: 60px;
        .result_box {
            display: flex;
            flex-direction: column;
            align-items: center;
            >img {
                display: inline-block;
                width: 72px;
                height: 72px;
            }
            .s_tips {
                text-align: center;
                h3 {
                    font-size: 24px;
                    color: #303133;
                    margin: 25px 0 10px;
                }
                p {
                    font-size: 14px;
                    color: #606266;
                }
            }
            .s_btns {
                margin-top: 40px;
                display: flex;
                justify-content: space-between;
                width: 214px;
                div {
                    width: 96px;
                    height: 32px;
                    border-radius: 4px;
                    text-align: center;
                    line-height: 32px;
                    font-size: 14px;
                    cursor: pointer;
                }
                .gray {
                    color: #606266;
                    border: 1px solid rgba(192,196,204);
                }
                .blue {
                    background: #409EFF;
                    color: #fff;
                }
            }
        }
        .fail,
        .success {
            .s_btns {
                justify-content: center;
            }
        }
    }
}
</style>
